module.exports = __webpack_public_path__ + "portal-static/img/receiving_commitment.682a5b1f.png";